export default "__VITE_ASSET__BfoiIZVX__"